exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-badge[data-v-5b9e7f2b]{position:relative}.d-badge--wrapper[data-v-5b9e7f2b]{-webkit-box-flex:0;-ms-flex:0 1;flex:0 1;height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%}.d-badge--badge[data-v-5b9e7f2b]{bottom:calc(100% - 17px);left:calc(100% - 7px);right:auto;border-radius:10px;font-size:11px;height:17px;letter-spacing:0;min-width:17px;padding:1px 4px;pointer-events:auto;position:absolute;text-align:center;text-indent:0;top:auto;-webkit-transition:.3s cubic-bezier(.25,.8,.5,1);transition:.3s cubic-bezier(.25,.8,.5,1);white-space:nowrap}", ""]);

// exports
